import { render, staticRenderFns } from "./position-modal.vue?vue&type=template&id=625f68b6&scoped=true"
import script from "./position-modal.vue?vue&type=script&lang=js"
export * from "./position-modal.vue?vue&type=script&lang=js"
import style0 from "./position-modal.vue?vue&type=style&index=0&id=625f68b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625f68b6",
  null
  
)

export default component.exports